<script setup lang="ts">
import { CAR_EVENT_TYPES, type CarEventType } from '../internal/types.ts'
import { useI18n } from 'vue-i18n'

defineEmits<{ select: [CarEventType] }>()
const { t } = useI18n()
</script>

<template>
  <div>
    <h3 class="mb-3 text-[length:var(--text-step-4)] font-semibold text-[color:var(--color-text)]">
      {{ t('garage.events.typeTitle') }}
    </h3>
    <div class="grid grid-cols-2 gap-[var(--space-cell)] sm:grid-cols-3 lg:grid-cols-4">
      <button
        v-for="type in CAR_EVENT_TYPES"
        :key="type"
        type="button"
        class="flex min-h-[var(--density-target-min)] flex-col items-start gap-1 rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-4 text-left transition-colors duration-[var(--motion-fast)] hover:border-[color:var(--color-border-control)]"
        @click="$emit('select', type)"
      >
        <span class="text-[length:var(--text-step-3)] font-medium text-[color:var(--color-text)]">{{
          t(`garage.eventType.${type}`)
        }}</span>
      </button>
    </div>
  </div>
</template>
